import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { RevisionTemplateSetStatusPayload } from 'api/actions/revision-template-set-status/revision-template-set-status-payload';
import { RevisionTemplateSetStatusPathParameters } from 'api/actions/revision-template-set-status/revision-template-set-status-path-parameters';
import { RevisionTemplateSetStatusResponse } from 'api/actions/revision-template-set-status/revision-template-set-status-response';

type RevisionTemplateSetStatusQueryParameters = Record<string, any>;

/**
 * The path of the RevisionTemplateSetStatus action.
 */
export const revisionTemplateSetStatusActionPath = new SweetPath<keyof RevisionTemplateSetStatusPathParameters>(
  '/api/revision-template/status/{revisionTemplateId}',
  { path: '{param}' }
);

/**
 * Creates a contextualized RevisionTemplateSetStatus actions.
 */
export default function createRevisionTemplateSetStatusAction(axios: AxiosInstance) {
  return function revisionTemplateSetStatusAction({
    headers = {},
    parameters,
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: RevisionTemplateSetStatusPathParameters;
    query?: RevisionTemplateSetStatusQueryParameters;
    payload: RevisionTemplateSetStatusPayload;
  }) {
    const path = revisionTemplateSetStatusActionPath.insert(parameters);

    return axios.request<RevisionTemplateSetStatusResponse, RevisionTemplateSetStatusResponse>({
      method: 'put',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
